/** Dependency-free SVG path catalogue for the Organization UI. */

export const ICON_PATHS: Record<string, string> = {
  logo: "M6 8.5A4.5 4.5 0 0 1 10.5 4h11A4.5 4.5 0 0 1 26 8.5v9a4.5 4.5 0 0 1-4.5 4.5H16l-6.5 5v-5A4.5 4.5 0 0 1 5 17.5v-9Z M11 11h10 M11 15h7",
  home: "M3 11.5 12 4l9 7.5M5.5 10.5V20h13v-9.5M9 20v-6h6v6",
  bolt: "M13 2 4.5 13H11l-1 9 8.5-12H12l1-8Z",
  pulse: "M3 12h4l2.5-6 4 12 2.5-6H21",
  calendar: "M6 3v3m12-3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z",
  check: "m5 12 4 4L19 6",
  building: "M4 21V5l8-3 8 3v16M8 8h2m4 0h2M8 12h2m4 0h2M8 16h2m4 0h2M10 21v-3h4v3",
  map: "M3 6.5 9 3l6 3.5L21 3v14.5L15 21l-6-3.5L3 21V6.5ZM9 3v14.5M15 6.5V21",
  layers: "m4 7 8-4 8 4-8 4-8-4Zm0 5 8 4 8-4M4 17l8 4 8-4",
  network: "M6 4h4v4H6V4Zm8 12h4v4h-4v-4ZM4 16h4v4H4v-4Zm4-10h8v5m0 0v5M6 16v-5h10",
  grid: "M4 4h6v6H4V4Zm10 0h6v6h-6V4ZM4 14h6v6H4v-6Zm10 0h6v6h-6v-6Z",
  users:
    "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm13 10v-2a4 4 0 0 0-3-3.87m-2-12a4 4 0 0 1 0 7.75",
  student: "M3 10l9-5 9 5-9 5-9-5Zm4 2.2V17c3 2 7 2 10 0v-4.8M21 10v6",
  teacher: "M4 4h16v11H4V4Zm3 16c1.5-3 8.5-3 10 0M9 8h6m-6 3h4",
  heart:
    "M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z",
  shield: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Zm-3-10 2 2 4-5",
  mail: "M3 5h18v14H3V5Zm0 1 9 7 9-7",
  lock: "M6 10h12v11H6V10Zm2 0V7a4 4 0 0 1 8 0v3",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  upload: "M12 16V4m0 0L7 9m5-5 5 5M5 15v5h14v-5",
  book: "M4 4h6a4 4 0 0 1 4 4v12a4 4 0 0 0-4-4H4V4Zm16 0h-6a4 4 0 0 0-4 4v12a4 4 0 0 1 4-4h6V4Z",
  library: "M4 20h16M5 17V7m4 10V4m4 13V8m4 9V5",
  path: "M5 4v5c0 3 3 3 5 3h4c3 0 5 2 5 5v3M15 17l4 3 4-3",
  swap: "M7 7h12l-3-3m3 3-3 3M17 17H5l3 3m-3-3 3-3",
  folder: "M3 6h7l2 2h9v12H3V6Z",
  video: "M3 5h13v14H3V5Zm13 5 5-3v10l-5-3",
  plus: "M12 5v14M5 12h14",
  play: "m8 5 11 7-11 7V5Z",
  clock: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-15v5l3 2",
  link: "M10 13a5 5 0 0 0 7.1.1l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1M14 11a5 5 0 0 0-7.1-.1l-2 2A5 5 0 0 0 12 20l1.1-1.1",
  flask: "M9 3h6M10 3v6l-5.5 9a2 2 0 0 0 1.7 3h11.6a2 2 0 0 0 1.7-3L14 9V3M7.5 15h9",
  key: "M15 7a5 5 0 1 0-4.6 7H13l2 2 2-2 2 2 2-2-4.2-4.2A5 5 0 0 0 15 7Z",
  clipboard: "M9 4h6l1 2h3v15H5V6h3l1-2Zm0 7h6m-6 4h6",
  certificate: "M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm-3 0-1 7 4-2 4 2-1-7",
  chart: "M4 20V10m5 10V4m5 16v-7m5 7V7",
  external: "M14 4h6v6m0-6-9 9M20 14v6H4V4h6",
  message: "M4 4h16v13H8l-4 4V4Z",
  layout: "M4 4h16v16H4V4Zm0 5h16M10 9v11",
  inbox: "M4 4h16v15H4V4Zm0 10h5l2 3h2l2-3h5",
  table: "M3 5h18v14H3V5Zm0 5h18M9 5v14m6-14v14",
  sliders: "M4 6h8m4 0h4M14 3v6M4 12h3m4 0h9M9 9v6M4 18h11m4 0h1M17 15v6",
  file: "M6 3h8l4 4v14H6V3Zm8 0v5h4M9 13h6m-6 4h6",
  gavel: "m14 5 5 5m-8-8 8 8m-12 2 5 5m-8 4h14M4 15l9-9 5 5-9 9",
  archive: "M4 7h16v14H4V7Zm-1-4h18v4H3V3Zm6 9h6",
  award: "M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm-4 0-1 7 5-3 5 3-1-7",
  rocket:
    "M14 4c4-2 6-1 6-1s1 2-1 6l-5 5-4-4 4-6ZM10 10l-4 1-3 3 6 1m5-1 1 6 3-3 1-4M7 17c-2 0-3 1-3 3 2 0 3-1 3-3Z",
  handshake: "M3 12l4-4 4 1 2-2 4 1 4 4-6 6-3-2-3 2-6-6Zm4-4-3-2m13 2 3-2",
  trophy: "M8 4h8v4c0 5-2 7-4 7s-4-2-4-7V4Zm0 2H4v2c0 3 2 4 4 4m8-6h4v2c0 3-2 4-4 4M12 15v4m-4 2h8",
  accessibility: "M12 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM4 7h16m-8 0v7m0 0-4 7m4-7 4 7m-7-10 3 2 3-2",
  wallet: "M4 6h15v14H4V6Zm0 3h16m-5 4h5v4h-5a2 2 0 0 1 0-4Z",
  briefcase: "M4 7h16v13H4V7Zm5 0V4h6v3M4 12h16m-9 0v2h2v-2",
  alert: "M12 3 2 21h20L12 3Zm0 6v5m0 3v1",
  search: "m21 21-4.4-4.4M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z",
  history: "M3 12a9 9 0 1 0 3-6.7L3 8m0-5v5h5M12 7v5l4 2",
  bot: "M8 5h8l2 3v9l-2 3H8l-2-3V8l2-3Zm4-3v3M9 11h.01M15 11h.01M9 16h6",
  trash: "M4 7h16M9 7V4h6v3m-9 0 1 14h10l1-14M10 11v6m4-6v6",
  target:
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  sparkles:
    "M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2ZM19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8L19 14ZM5 14l.8 2.2L8 17l-2.2.8L5 20l-.8-2.2L2 17l2.2-.8L5 14Z",
  monitor: "M3 4h18v13H3V4Zm6 17h6m-3-4v4",
  gift: "M4 10h16v11H4V10Zm-1-4h18v4H3V6Zm9 0v15m0-15c-2-4-6-4-6-1 0 1 2 1 6 1Zm0 0c2-4 6-4 6-1 0 1-2 1-6 1Z",
  cart: "M3 4h2l2 11h10l3-8H6M9 20h.01M17 20h.01",
  receipt: "M6 3h12v19l-3-2-3 2-3-2-3 2V3Zm3 5h6m-6 4h6m-6 4h4",
  database:
    "M4 5c0-2 4-3 8-3s8 1 8 3-4 3-8 3-8-1-8-3Zm0 0v7c0 2 4 3 8 3s8-1 8-3V5m-16 7v7c0 2 4 3 8 3s8-1 8-3v-7",
  code: "m8 9-4 3 4 3m8-6 4 3-4 3m-3-9-2 12",
  download: "M12 4v12m0 0 5-5m-5 5-5-5M5 20h14",
  settings:
    "M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0-13 1 2.2 2.4.6 2-1.4 1.7 1.7-1.4 2 .6 2.4 2.2 1 2.2-1 2.4.6 1.4 2-1.7 2-2.4-.6-1 2.2H9.6l-1-2.2-2.4-.6-2 1.4-1.7-1.7 1.4-2-.6-2.4-2.2-1 1-2.2-.6-2.4-1.4-2 1.7-1.7 2 1.4 2.4-.6 1-2.2H12Z",
  globe: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0 0c3 0 5-4 5-10S15 2 12 2 7 6 7 12s2 10 5 10ZM2 12h20",
  bell: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Zm-8 12h4",
  close: "M6 6l12 12M18 6 6 18",
  chevron: "m9 18 6-6-6-6",
  menu: "M4 7h16M4 12h16M4 17h16",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  copy: "M8 8h11v11H8V8Zm-3 8H4V4h12v1",
  filter: "M4 5h16l-6 7v6l-4 2v-8L4 5Z",
  arrow: "M5 12h14m-5-5 5 5-5 5",
  info: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-11v6m0-10h.01",
  user: "M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM3 22a9 9 0 0 1 18 0",
  logout: "M10 4H4v16h6m5-4 4-4-4-4m4 4H9",
  help: "M9.1 9a3 3 0 1 1 5.8 1c0 2-3 2-3 5m.1 3h.01M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z",
};
